import { StyleSheet } from '@react-pdf/renderer'

import colors from '@/constants/colors'

export const TRANSCRIPT_STYLES = StyleSheet.create({
  sectionHeader: {
    fontFamily: 'greycliffcf',
    fontWeight: 600,
    fontSize: '16px',
    marginTop: '8px',
    marginBottom: '8px',
  },
  eyebrowHeader: {
    fontFamily: 'greycliffcf',
    fontSize: '8px',
    fontWeight: 700,
    textTransform: 'uppercase',
    color: colors.gray[500],
    marginBottom: '8px',
    marginTop: '8px',
  },
})
